import { styled } from "styled-components";

import { Timestamp } from "../Timestamp";

export const Debug = styled.div(({ theme }) => {
  return {
    fontSize: "12px",
    lineHeight: "17px",
    color: theme.colors.grayDark,
    marginTop: theme.space[2],
  };
});

export const Container = styled.div(() => {
  return {
    display: "flex",
    flexDirection: "column",
    flexShrink: 0,
    alignItems: "flex-end",
  };
});

export const Row = styled.div(() => {
  return {
    display: "flex",
    width: "100%",
    alignItems: "center",

    [`& ${Timestamp.Container}`]: {
      flexGrow: 1,
      marginRight: 8,
      textAlign: "end",
      opacity: "0%",
      transition: "opacity 0.2s ease-in-out",
    },

    [`&:hover ${Timestamp.Container}`]: {
      opacity: "100%",
    },
  };
});
